import { ActiveCredit, Credit } from '../../store/credits/creditsTypes';
import { MyActivityPayment } from '../../store/my-activities/myActivitiesTypes';

export const getTheRightCredit = (
  credits: Credit[],
  price: number,
  payments: MyActivityPayment[] = []
): {
  credits: ActiveCredit[];
  creditsLeft: number;
  balanceToPay: number;
  creditInUse: number;
} => {
  const totalCashAmount = payments.reduce((total, payment) => {
    return total + +(payment.cashAmount || 0);
  }, 0);

  let moneyToPay = price - totalCashAmount;
  let creditInUse = 0;
  let creditsLeft = 0;
  const newCredits = sortCreditsByEndDate([...credits]);
  const creditsInUse: ActiveCredit[] = [];

  newCredits.forEach((credit) => {
    if (moneyToPay && Number(credit.amount) > Number(credit.usage)) {
      const creditMoney = credit.amount - credit.usage;

      let moneyFromCredit;

      if (moneyToPay > creditMoney) {
        moneyFromCredit = creditMoney;
      } else {
        moneyFromCredit = moneyToPay;
        creditsLeft = creditsLeft + (creditMoney - moneyFromCredit);
      }

      creditInUse = creditInUse + moneyFromCredit;
      moneyToPay = moneyToPay - moneyFromCredit;

      creditsInUse.push({
        id: credit.id,
        amount: moneyFromCredit,
      });
    }
  });

  return {
    credits: creditsInUse,
    creditsLeft,
    balanceToPay: moneyToPay + totalCashAmount,
    creditInUse,
  };
};

const sortCreditsByEndDate = (credits: Credit[]) => {
  return credits.sort((creditA, creditB) => {
    if (
      (creditA.endDate === -1 || !creditA.endDate) &&
      (creditB.endDate === -1 || !creditB.endDate)
    ) {
      return 0;
    }
    if (creditA.endDate === -1 || !creditA.endDate) {
      return 1;
    }
    if (creditB.endDate === -1 || !creditB.endDate) {
      return -1;
    }
    return creditA.endDate - creditB.endDate;
  });
};
